import Parse from 'parse/dist/parse.min.js'; // Import Parse SDK

const APP_ID = '3ZraCGVEMT8vTcJXzKKiZ65OQ9dsJJqo3wDgneHM';
const JS_KEY = 'hQkocwX7BFcwJ5aOYqE7rtbmBqRxeIw9aiLuf7Cp';

Parse.initialize(APP_ID, JS_KEY);
Parse.serverURL = 'https://mobile413.b4a.io';

export default Parse